module.exports = __webpack_public_path__ + "img/cover-promotion-bg.3d7b771e.jpg";